import { render, staticRenderFns } from "./CandidateReports.vue?vue&type=template&id=6a05dd02&"
import script from "./CandidateReports.vue?vue&type=script&lang=js&"
export * from "./CandidateReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports